import clsx from 'clsx';

const LoadingSpinner = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'w-4 h-4 border',
    md: 'w-8 h-8 border',
    lg: 'w-12 h-12 border',
    xl: 'w-16 h-16 border',
  };

  return (
    <div
      className={clsx(
        'inline-block rounded-full border-solid border-primary-500 border-t-transparent animate-spin',
        sizeClasses[size],
        className
      )}
      role="status"
      aria-label="Loading"
    >
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export default LoadingSpinner;
